import { Inject, LOCALE_ID, NgModule } from '@angular/core';
import { TranslateCompiler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import { LocalesEnum } from './constants/locales.enum';
import { translateBrowserLoaderFactory } from '~shared/loaders/translate-browser.loader';
import { TransferState } from '@angular/platform-browser';


@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateBrowserLoaderFactory,
        deps: [HttpClient, TransferState]
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    })
  ],
  exports: [TranslateModule],
})
export class L10nModule {
  constructor(
    private readonly translate: TranslateService,
    @Inject(LOCALE_ID) protected localeId: string,
  ) {
    this.translate.addLangs([
      LocalesEnum.en,
      LocalesEnum.de,
      LocalesEnum.es,
      LocalesEnum.it,
      LocalesEnum.pt,
      LocalesEnum.nl,
      LocalesEnum.fr
    ]);
    this.localeId
      ? this.translate.use(this.localeId)
      : this.translate.setDefaultLang(LocalesEnum.de);
  }
}
